( function( $ ) {
	$( document ).ready( function() {
		document.addEventListener( "facetwp-loaded", function() {
			if ( ! $( "#facetwp-map" ).length > 0 ) {
				FWP.refresh();
			}
		}, { once: true } );

		$( ".facetwp-filters-selection__button" ).click( function() {
			if ( $( ".facetwp-filters-selection__block" ).hasClass( "open" ) ) {
				$( ".facetwp-filters-selection__block" ).removeClass( "open" );
			} else {
				$( ".facetwp-filters-selection__block" ).addClass( "open" );
			}
		} );

		$( ".facetwp-filters-selection__button--primary" ).click( function() {
			$( ".facetwp-filters-selection__block" ).removeClass( "open" );
		} );
	} );
}( jQuery ) );
